// First view of a search: ranked pins and camera, straight from the map worker's decoded catalog. The nationwide model (every site as a
// dot) is built behind it, so neither its size nor the page's slow copy of the catalog delays the hits.
// env: pipeline, hits, filters, origin, cap (closest zoom), early (false while prices or the price badge are still missing),
// view() (measured free area), draw(features), isCurrent(). Resolves to {camera, coords}, or null when a newer search replaced this one.
export async function startSearch({pipeline, hits, filters, origin, cap, early, view, draw, isCurrent}) {
  // Both requests leave now, in this order; the worker answers the pins first.
  const peek = early && hits.length ? pipeline.peek(hits, filters).catch(() => null) : null;
  const frame = origin.point || hits.length ? pipeline.searchCamera(origin.point, hits, filters, view(), cap).catch(() => null) : null;
  const features = peek && await peek;
  if (!isCurrent()) return null;
  if (features) draw(features);
  const framed = frame && await frame;
  if (!isCurrent()) return null;
  return {camera: framed ? {...framed.camera, bearing: 0, pitch: 0} : null, coords: framed?.coords ?? []};
}
